import React, { FC } from 'react';
import { Outlet } from 'react-router';

const DevelopmentFinancing: FC = () => {
  return <Outlet />;
};

export default DevelopmentFinancing;
